// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1fcYj","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2v2l4"};